'use client'
import { useBreadcrumbs } from '../hooks/UseBreadcrumbs'
import styles from './Breadcrumbs.module.scss'
import { Hyperlink } from '@/tools/ui'

export function Breadcrumbs() {
  const { breadcrumbRoutes } = useBreadcrumbs()
  return (
    <div className={styles.wrapper}>
      {breadcrumbRoutes.map((crumb, i) => {
        if (!crumb.name) {
          return null
        }
        if (i === breadcrumbRoutes.length - 1) {
          return (
            <span key={crumb.path} className={styles.inactive}>
              {crumb.name}
            </span>
          )
        }
        return (
          <span key={crumb.path} className={styles.link}>
            <Hyperlink href={crumb.path}>{crumb.name}</Hyperlink>
            <p className={styles.slash}>{' / '}</p>
          </span>
        )
      })}
    </div>
  )
}
